<template>
  <div class="container flex-column flex-justify-start flex-align-start">
    <div class="wx-line flex-row flex-justify-start flex-align-start">
      <div class="chart1 card-gap flex-column flex-justify-start flex-align-start">
        <div class="chart-head flex-row flex-justify-start flex-align-start">维修数量统计</div>
        <div class="chart-contain flex-row flex-justify-center flex-align-start">
          <div id="sltjref" class="chart-area"></div>
        </div>
      </div>
      <div class="chart1 flex-column flex-justify-start flex-align-start">
        <div class="chart-head flex-row flex-justify-start flex-align-start">设备维修比例</div>
        <div class="chart-contain flex-row flex-justify-center flex-align-start">
          <div id="sbblref" class="chart-area"></div>
        </div>
      </div>
    </div>
    <div class="wx-line flex-row flex-justify-start flex-align-start">
      <div class="chart2 flex-column flex-justify-start flex-align-start">
        <div class="chart-head flex-row flex-justify-start flex-align-start">维修数量统计</div>
        <div class="chart-contain flex-row flex-justify-start flex-align-start">
          <div class="flex-column flex-justify-start flex-align-center" style="width: 100%;margin-bottom: 20px;" >
            <div class="tb-head flex-row flex-justify-start flex-align-start">
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>编号</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>设备编号</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>设备名称</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>设备类型</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>故障说明</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>故障图片</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>故障时间</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>解决说明</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>解决图片</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>解决时间</span>
              </div>
            </div>
            <div class="tb-line flex-row flex-justify-start flex-align-center" v-for="(item, index) in tableData.weixiu" :key="index">
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ index }}</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ item.sn }}</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ item.name }}</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ item.devtype }}</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ item.errlog }}</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <el-image style="width: 20px; height: 20px" :src="item.errimg" :preview-src-list="[item.errimg]"></el-image>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ item.errdate }}</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ item.repairlog }}</span>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <el-image style="width: 20px; height: 20px" :src="item.repairimg" :preview-src-list="[item.repairimg]"></el-image>
              </div>
              <div class="flex-row flex-justify-center flex-align-center" style="width: 10%;">
                <span>{{ item.repairdate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {getWxFenxi} from '@/api/engery.js'
import * as echarts from 'echarts'

export default {
  name: 'WxChart',
  props: {
    initdone: {
      type: Boolean,
      default: false
    },
    timedate: {
      type: Object,
      default: () => ({
        starttime: '',
        endtime: ''
      })
    }
  },
  data() {
    return {
      chart: null,
      charte: null,
      tableData: {
        waters: 0,
        elect: 0,
        cold: 0,
        liuliang: 0,
        xdata: [],
        y1data: [],
        y2data: [],
        y3data: [],
        y4data: [],
        weixiu: []
      }
    }
  },
  watch: {
    initdone: {
      handler() {
        this.$nextTick(async () => {
          try {
            const response = await getWxFenxi(this.timedate)
            this.tableData.waters = response.data.waters
            this.tableData.elect = response.data.elect
            this.tableData.cold = response.data.cold
            this.tableData.liuliang = response.data.liuliang
            this.tableData.xdata = response.data.xdata
            this.tableData.y1data = response.data.y1data
            this.tableData.y2data = response.data.y2data
            this.tableData.y3data = response.data.y3data
            this.tableData.y4data = response.data.y4data
            this.tableData.weixiu = response.data.weixiu
            this.initChart()
            this.initCharte()
          } catch (error) {
            console.error(error)
          }
        })
      }
    }
  },
  beforeDestroy() {
    if(this.chart != null) {
      this.chart.dispose()
      this.chart = null
    }
    if(this.charte != null) {
      this.charte.dispose()
      this.charte = null
    }
  },
  methods: {
    initChart() {
      var chartDom = null
      chartDom = document.getElementById('sltjref')
      if(!chartDom) {
        return
      }
      if (!this.chart) {
        this.chart = echarts.init(chartDom)
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: ['电表', '水表', '空气流量计', '制冷机']
        },
        xAxis: [
          {
            type: 'category',
            data: this.tableData.xdata,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量 / 个',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '电表',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#97c4ff'
            },
            data: this.tableData.y1data
          },
          {
            name: '水表',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#ff9f9f'
            },
            data: this.tableData.y2data
          },
          {
            name: '空气流量计',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#6aa4cf'
            },
            data: this.tableData.y3data
          },
          {
            name: '制冷机',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#f7cd85'
            },
            data: this.tableData.y4data
          }
        ]
      }
      this.chart.setOption(option)
    },
    initCharte() {
      var chartDom = null
      chartDom = document.getElementById('sbblref')
      if(!chartDom) {
        return
      }
      if (!this.charte) {
        this.charte = echarts.init(chartDom)
      }
      var option = {
        tooltip: {
          trigger: 'item',
          extraCssText: 'text-align: left;',
        },
        legend: {
          bottom: '5%', left: 'center'
        },
        series: [
          {
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            name: '设备维修比例',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {value: this.tableData.waters, name: '水表'},
              {value: this.tableData.elect, name: '电表'},
              {value: this.tableData.cold, name: '制冷机'},
              {value: this.tableData.liuliang, name: '空气流量计'}
            ]
          },
        ]
      }
      this.charte.setOption(option)
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
}
.wx-line {
  width: 100%;
}
.card-gap {
  margin-right: 1%;
}
.chart1 {
  width: 49.5%;
  margin-top: 10px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.chart2 {
  width: 100%;
  min-height: 400px;
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.chart-head {
  font-family: 'Arial';
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 10px;
}
.chart-contain {
  width: 100%;
  overflow: hidden;
}
.chart-area {
  min-width: 800px;
  min-height: 400px;
}
.tb-head {
  width: 96%;
  min-height: 30px;
  margin-top: 10px;
  background-color: #e8f1ff;
  font-family: 'Arial';
  font-size: 14px;
  color: #3d5ad0;
}
.tb-line {
  width: 96%;
  min-height: 30px;
  font-family: 'Arial';
  font-size: 14px;
  color: #c0c0c0;
}
</style>
